/*eslint-disable */
import React, { FC, useEffect } from "react";
import { createUseStyles, useTheme } from "react-jss";
import clsx from "clsx";
import styles from "./styles";

interface Props {
  embedId: any;
  alt?: string;
  className?: any;
  style?: {};
  onClick?: (e: any) => void;
  onError?: (e: any) => void;
  width?: any;
  height?: any;
  top?: any;
  left?: any;
  iframeHeight?: any;
  iframeWidth?: any;
  children?: any;
  isCampusReel?: boolean;
}

const InstagramObject: FC<Props> = ({
  embedId,
  alt,
  className,
  style,
  onClick,
  onError,
  children,
  isCampusReel = false,
  ...props
}: Props) => {
  const theme = useTheme();
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });
  const src = isCampusReel ? embedId : `https://www.instagram.com/p/${embedId}/embed`;

  return (
    <button
      aria-label={alt}
      onClick={onClick}
      className={clsx(classes.image, className)}
      style={style}
    >
      <iframe
        aria-hidden="true"
        tabIndex={-1}
        className={classes.iframe}
        src={src}
        frameBorder="0"
        scrolling="no"
      ></iframe>
      {children && <div className={classes.mediaIcon}>{...children}</div>}
    </button>
  );
};

export default InstagramObject;
